import { AUDIO_TYPE, FILE_UPLOAD_TYPE, IMAGE_TYPE, VIDEO_TYPE } from "./../../ricos-content";
import { isSSR } from "./../../wix-rich-content-common";
import {
  getFilePluginComponentData,
  getHighestQualityVideo
} from "../uploadStrategy/uploadStrategy";
import { createMediaMangerOpener, MediaManagerMediaType } from "./mediaManagerPanel";
const getFilePluginComponentDataFromMediaManager = (file) => {
  const { title: name, fileUrl, fileName, fileSize: size, fileOutput } = file;
  let url = fileUrl;
  let type = (fileName.split(".").length === 1 ? name : fileName).split(".").pop();
  if (fileOutput?.video) {
    const video = getHighestQualityVideo(fileOutput.video);
    url = video.url;
    type = video.format;
  }
  if (!type) {
    type = "unknown";
    console.error("could not determine file type for file:", file);
  }
  return getFilePluginComponentData(name, url, type, "public", size);
};
function mediaManagerStrategy(hasPlugin, appDefId) {
  if (isSSR()) {
    return {
      config: {}
    };
  }
  const mediaManagerInstance = window.editorSDK || window.ModuleRegistry;
  const isInEditor = mediaManagerInstance && "editor" in mediaManagerInstance;
  const isInBM = mediaManagerInstance && "registeredMethods" in mediaManagerInstance && mediaManagerInstance.registeredMethods && typeof mediaManagerInstance.registeredMethods === "object" && "mediaManager.open" in mediaManagerInstance.registeredMethods;
  if (!mediaManagerInstance || !isInEditor && !isInBM) {
    return {
      config: {}
    };
  }
  const openMediaManager = createMediaMangerOpener(mediaManagerInstance);
  const imageUpload = (index, multiple, updateEntity) => {
    openMediaManager({
      mediaType: MediaManagerMediaType.IMAGE,
      appDefId,
      isMultiSelect: multiple,
      onSuccess(items) {
        const imageData = items.map(
          ({
            title,
            uri,
            height,
            width
          }) => ({
            id: uri,
            height,
            width,
            original_file_name: title,
            file_name: uri
          })
        );
        updateEntity({
          data: imageData,
          index
        });
      }
    });
  };
  const videoUpload = (updateEntity) => {
    openMediaManager({
      mediaType: MediaManagerMediaType.VIDEO,
      appDefId,
      onSuccess(items) {
        const { video, image, fullTitle, title } = items[0].fileOutput;
        const { url: pathname } = getHighestQualityVideo(video);
        const { url, width, height } = image[0];
        const thumbnail = { pathname: url, width, height };
        const videoTitle = fullTitle ?? title;
        const titleObject = videoTitle ? { title: videoTitle } : {};
        updateEntity({ data: { pathname, thumbnail, ...titleObject } });
      }
    });
  };
  const audioUpload = (updateEntity, _removeEntity, isCoverImage) => {
    const mediaType = isCoverImage ? MediaManagerMediaType.IMAGE : MediaManagerMediaType.AUDIO;
    openMediaManager({
      mediaType,
      appDefId,
      onSuccess(items) {
        const file = items[0];
        if (isCoverImage) {
          const { uri, width, height, title } = file;
          updateEntity({
            data: { id: uri, file_name: uri, original_file_name: title, width, height }
          });
        } else {
          const { audio } = file.fileOutput;
          const name = file.title.split(".")[0];
          updateEntity({
            data: { audio: { src: { id: audio[0].url } }, name }
          });
        }
      }
    });
  };
  const fileUpload = (updateEntity) => {
    openMediaManager({
      mediaType: MediaManagerMediaType.ALL_MEDIA,
      appDefId,
      onSuccess(items) {
        const componentData = getFilePluginComponentDataFromMediaManager(items[0]);
        updateEntity({ data: [componentData] });
      }
    });
  };
  return {
    helpers: { ...hasPlugin(IMAGE_TYPE) && { handleFileSelection: imageUpload } },
    config: {
      ...hasPlugin(VIDEO_TYPE) && {
        [VIDEO_TYPE]: {
          handleFileSelection: videoUpload
        }
      },
      ...hasPlugin(AUDIO_TYPE) && {
        [AUDIO_TYPE]: {
          handleFileSelection: audioUpload
        }
      },
      ...hasPlugin(FILE_UPLOAD_TYPE) && {
        [FILE_UPLOAD_TYPE]: {
          handleFileSelection: fileUpload
        }
      }
    }
  };
}
export {
  mediaManagerStrategy as default,
  getFilePluginComponentDataFromMediaManager
};
//# sourceMappingURL=mediaManagerStrategy.js.map
